import React, { Component } from 'react';
import { withFirebase } from '../Firebase';
import { withRouter } from 'react-router-dom';
import './CustomerDetailsPage.css';

class CustomerDetailsPageBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agreement: null,
      onboarding: null,
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    this.loadCustomerData();
  }

  loadCustomerData = async () => {
    const { agreementId } = this.props.match.params;
    
    try {
      // Load agreement
      const agreementDoc = await this.props.firebase.db
        .collection('franchiseAgreements')
        .doc(agreementId)
        .get();
      
      if (!agreementDoc.exists) {
        this.setState({ error: 'Agreement not found', loading: false });
        return;
      }
      
      const agreement = { id: agreementDoc.id, ...agreementDoc.data() };
      
      // Load onboarding data
      let onboarding = null;
      const onboardingQuery = await this.props.firebase.db
        .collection('franchiseOnboarding')
        .where('userId', '==', agreement.userId)
        .limit(1)
        .get();
      
      if (!onboardingQuery.empty) {
        const onboardingDoc = onboardingQuery.docs[0];
        onboarding = { id: onboardingDoc.id, ...onboardingDoc.data() };
      }
      
      this.setState({ agreement, onboarding, loading: false });
    } catch (error) {
      console.error('Error loading customer data:', error);
      this.setState({ error: error.message, loading: false });
    }
  };

  render() {
    const { agreement, onboarding, loading, error } = this.state;

    if (loading) {
      return (
        <div className="customer-details-page">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Loading customer details...</p>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="customer-details-page">
          <div className="error-message">
            <h2>❌ Error</h2>
            <p>{error}</p>
            <button onClick={() => window.close()}>Close</button>
          </div>
        </div>
      );
    }

    if (!agreement) {
      return (
        <div className="customer-details-page">
          <div className="error-message">
            <h2>❌ Not Found</h2>
            <p>Customer details not found.</p>
            <button onClick={() => window.close()}>Close</button>
          </div>
        </div>
      );
    }

    return (
      <div className="customer-details-page">
        <div className="customer-details-header">
          <h1>📋 Customer Details</h1>
          <button onClick={() => window.close()} className="close-btn">✕ Close</button>
        </div>

        {/* Basic Agreement Info */}
        <div className="details-section">
          <h2>👤 Basic Information</h2>
          <div className="details-grid">
            <div className="detail-item">
              <label>Full Name</label>
              <p>{agreement.formData?.fullName || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>Email</label>
              <p>{agreement.formData?.email || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>Phone</label>
              <p>{agreement.formData?.phone || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>Entity Type</label>
              <p style={{ textTransform: 'capitalize' }}>
                {agreement.formData?.entityType || 'N/A'}
              </p>
            </div>
            <div className="detail-item">
              <label>RERA Number</label>
              <p>{agreement.formData?.reraNumber || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>City</label>
              <p>{agreement.formData?.city || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>State</label>
              <p>{agreement.formData?.state || 'N/A'}</p>
            </div>
            <div className="detail-item">
              <label>Agreement Date</label>
              <p>{agreement.createdAt ? new Date(agreement.createdAt.seconds * 1000).toLocaleDateString() : 'N/A'}</p>
            </div>
          </div>
        </div>

        {/* Onboarding Forms Data */}
        {onboarding ? (
          <>
            {/* Step 1: Business Information */}
            {onboarding.step1 && (
              <div className="details-section">
                <h2>🏢 Business Information (Step 1)</h2>
                <div className="details-grid">
                  <div className="detail-item">
                    <label>Territory</label>
                    <p>{onboarding.step1.territory || 'N/A'}</p>
                  </div>
                  <div className="detail-item">
                    <label>Team Size</label>
                    <p>{onboarding.step1.teamSize || 'N/A'}</p>
                  </div>
                  <div className="detail-item">
                    <label>Business Experience</label>
                    <p>{onboarding.step1.businessExperience || 'N/A'}</p>
                  </div>
                  <div className="detail-item full-width">
                    <label>Investment Capacity</label>
                    <p>{onboarding.step1.investmentCapacity || 'N/A'}</p>
                  </div>
                </div>
              </div>
            )}

            {/* Step 2: Additional Details */}
            {onboarding.step2 && (
              <div className="details-section">
                <h2>📝 Additional Details (Step 2)</h2>
                <div className="details-grid">
                  {Object.entries(onboarding.step2).map(([key, value]) => (
                    <div className="detail-item" key={key}>
                      <label style={{ textTransform: 'capitalize' }}>
                        {key.replace(/([A-Z])/g, ' $1').trim()}
                      </label>
                      <p>{value || 'N/A'}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Step 3 */}
            {onboarding.step3 && (
              <div className="details-section">
                <h2>📋 Form Step 3</h2>
                <div className="details-grid">
                  {Object.entries(onboarding.step3).map(([key, value]) => (
                    <div className="detail-item" key={key}>
                      <label style={{ textTransform: 'capitalize' }}>
                        {key.replace(/([A-Z])/g, ' $1').trim()}
                      </label>
                      <p>{typeof value === 'object' ? JSON.stringify(value) : (value || 'N/A')}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Step 4 */}
            {onboarding.step4 && (
              <div className="details-section">
                <h2>📋 Form Step 4</h2>
                <div className="details-grid">
                  {Object.entries(onboarding.step4).map(([key, value]) => (
                    <div className="detail-item" key={key}>
                      <label style={{ textTransform: 'capitalize' }}>
                        {key.replace(/([A-Z])/g, ' $1').trim()}
                      </label>
                      <p>{typeof value === 'object' ? JSON.stringify(value) : (value || 'N/A')}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Step 5 */}
            {onboarding.step5 && (
              <div className="details-section">
                <h2>📋 Form Step 5</h2>
                <div className="details-grid">
                  {Object.entries(onboarding.step5).map(([key, value]) => (
                    <div className="detail-item" key={key}>
                      <label style={{ textTransform: 'capitalize' }}>
                        {key.replace(/([A-Z])/g, ' $1').trim()}
                      </label>
                      <p>{typeof value === 'object' ? JSON.stringify(value) : (value || 'N/A')}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Onboarding Status */}
            <div className="details-section">
              <h2>📊 Onboarding Status</h2>
              <div className="details-grid">
                <div className="detail-item">
                  <label>Current Step</label>
                  <p>{onboarding.currentStep || 1} of 5</p>
                </div>
                <div className="detail-item">
                  <label>Status</label>
                  <p style={{
                    color: onboarding.completed ? '#10b981' : '#f59e0b',
                    fontWeight: 'bold'
                  }}>
                    {onboarding.completed ? '✅ Completed' : '⏳ In Progress'}
                  </p>
                </div>
                {onboarding.completedAt && (
                  <div className="detail-item">
                    <label>Completed At</label>
                    <p>{new Date(onboarding.completedAt.seconds * 1000).toLocaleString()}</p>
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
          <div className="details-section">
            <div className="empty-message">
              <h3>📭 No Onboarding Data</h3>
              <p>This customer has not started the onboarding process yet.</p>
            </div>
          </div>
        )}

        {/* Payment Information */}
        {agreement.paymentCompleted && (
          <div className="details-section success-section">
            <h2>💳 Payment Information</h2>
            <div className="details-grid">
              <div className="detail-item">
                <label>Payment Status</label>
                <p style={{ color: '#10b981', fontWeight: 'bold' }}>✅ Completed</p>
              </div>
              {agreement.paymentId && (
                <div className="detail-item">
                  <label>Payment ID</label>
                  <p>{agreement.paymentId}</p>
                </div>
              )}
              {agreement.paymentCompletedAt && (
                <div className="detail-item">
                  <label>Payment Date</label>
                  <p>{new Date(agreement.paymentCompletedAt.seconds * 1000).toLocaleString()}</p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

const CustomerDetailsPage = withRouter(withFirebase(CustomerDetailsPageBase));

export default CustomerDetailsPage;

